import React, { PropsWithChildren } from "react";
//#region types
import { FormExpansionPanelProps } from "models/propTypes/panelsPropsTypes";
//#endregion
//#region components
import { Accordion, AccordionSummary, AccordionDetails, Grid } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { ErrorBoundary } from "components/error";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";

const FormExpansionPanel: React.FC<PropsWithChildren<FormExpansionPanelProps>> = (props) => {
  return (
    <Grid item container className={clsx(cssExports.formExpansionPanelContainer, props.className)}>
      <Accordion
        className={cssExports.formExpansionPanel}
        defaultExpanded={props.defaultExpanded ?? false}
        expanded={props.expanded}
        onChange={props.onChange}
      >
        <AccordionSummary
          classes={{
            root: cssExports.formExpansionPanelSummary,
            content: cssExports.formExpansionPanelSummaryContent,
            expandIconWrapper: clsx(cssExports.formExpansionPanelIcon, props.iconClassName),
          }}
          expandIcon={<ExpandMoreIcon />}
          aria-controls="form-expansion-panel-content"
          id="form-expansion-panel-header"
          className={cssExports.expansionPanelBorderLess}
        >
          <Grid container direction="row" flexWrap="nowrap" alignItems="center">
            <Grid item className={cssExports.formExpansionPanelTitle}>
              {props.title}
            </Grid>
          </Grid>
        </AccordionSummary>
        <AccordionDetails
          classes={{
            root: cssExports.formExpansionPanelDetails,
          }}
        >
          <ErrorBoundary>
            <Grid item container direction="column">
              {props.children}
            </Grid>
          </ErrorBoundary>
        </AccordionDetails>
      </Accordion>
    </Grid>
  );
};

export default FormExpansionPanel;
